import { testMsg } from "../test-apis";
import { isTestCompany } from "../utils/auth";
import http from "../utils/http";
import { toast } from "../utils/toast";

// 코멘트 조회
// params = {postIdx, postType}
export const getComents = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/comments/list", {
        offset: 0,
        limit: 1000,
        ...params
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 코멘트 작성 등록
// params = {postIdx, postType, uploadFiles, content}
// uploadFiles, content 둘중 하나는 필수
export const createComent = (params) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post("/comments", {
        countPerPage: 10,
        ...params
      })
      .then((res) => {
        toast.success('코멘트가 작성되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        toast.error('코멘트 작성에 실패했습니다.');
        reject(err);
      });
  });
};

// 코멘트 삭제
export const deleteComent = (commentIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .delete(`/comments/${commentIdx}`)
      .then((res) => {
        toast.success('코멘트가 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        toast.error('코멘트 삭제에 실패했습니다.');
        reject(err);
      });
  });
};

// 코멘트 수정
export const modifyComent = (commentIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .put(`/comments/${commentIdx}`, body)
      .then((res) => {
        toast.success('코멘트가 수정되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        toast.error('코멘트 수정에 실패했습니다.');
        reject(err);
      });
  });
};

export const reaction = (params) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http.post("/comments/reaction", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getReactions = (commentIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http.get(`/comments/reaction/${commentIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};